// extracted by mini-css-extract-plugin
export default {"link":"NavigationItem_link__T-J+8","shrink-grow":"NavigationItem_shrink-grow__4+CkN"};